import axios from 'axios';
import {saveStream} from '../../../utils/http/saveStream';
import {FeedbackDTO} from "../../model";
import Filter from "../../../utils/query/pg/Filter";

const getFeedbacks = (query) => {
    const json = JSON.stringify(query);
    return axios
        .post('/api/feedback/_search', json, {
            headers: {'Content-type': 'application/json'}
        })
        .then(response => response.data);
};

/**
 * @return {Promise<T>}
 */
const getFeedback = (id: string, fields: Array<string> = undefined) => {
    let queryParams = '';
    if (fields) {
        queryParams += "?fields=" + fields.map(value => encodeURIComponent(value)).join(",");
    }

    let uri = `/api/feedback/${encodeURIComponent(id)}${queryParams}`;
    return axios.get(uri, {
        headers: {'Content-type': 'application/json', 'Accept': 'application/json'}
    }).then(response => response.data);
};

const getFeedbackDebug = (veckoId: string, stream: string, tenant: string) => {
    let queryParams = `?stream=${stream}&tenant=${tenant}`;
    let uri = `/api/feedback/debug/${encodeURIComponent(veckoId)}${queryParams}`;
    return axios.get(uri, {
        headers: {'Content-type': 'application/json', 'Accept': 'application/json'}
    }).then(response => {
        const feedbackDTO = response.data as FeedbackDTO;
        feedbackDTO.debug.status.sort((a, b) => b.date - a.date)
        return feedbackDTO;
    });
};

//No more used but keep it for a while in case we need it in the future
const getFeedbackDebugByExternalId = (externalId: string, tenant: string) => {
    let queryParams = `?externalId=${externalId}&tenant=${tenant}`;
    let uri = `/api/feedback/debug${queryParams}`;
    return axios.get(uri, {
        headers: {'Content-type': 'application/json', 'Accept': 'application/json'}
    }).then(response => {
        const feedbackDTOs = response.data as FeedbackDTO[];
        feedbackDTOs.forEach(feedbackDTO => feedbackDTO.debug.status.sort((a, b) => b.date - a.date));
        return feedbackDTOs;
    });
};

const getFeedbackStats = (filter) => {
    const json = JSON.stringify(filter);
    return axios
        .post('/api/feedback/_stats', json, {
            headers: {'Content-type': 'application/json', 'Accept': 'application/json'}
        })
        .then(response => response.data);
};

const exportFeedbackStats = (filter) => {
    return saveStream({
        url: '/api/feedback/_stats',
        method: 'POST',
        body: filter,
        headers: {
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        fallbackFileName: 'feedbacks-stats.xlsx'
    });
};

const getFeedbacksForAdmin = (page: number, pageSize: number, tenant: string, filters: Array<Filter>) => {
    let url = `/api/feedback?page=${page - 1}&pageSize=${pageSize}&tenant=${tenant}`;
    filters.forEach(value => url += '&' + value.toQueryString())

    return axios
        .get(url, {
            headers: {'Content-type': 'application/json'}
        })
        .then(response => {
            return response.data;
        });
};

const replayFeedbacks = (tenant: string, filters: Array<Filter>) => {
    let url = `/api/feedback/replay?tenant=${tenant}`;
    filters.forEach(value => url += '&' + value.toQueryString())

    return axios
        .get(url, {
            headers: {'Content-type': 'application/json'}
        })
        .then(response => {
            return response.data;
        });
};


const deleteFeedbacks = (query) => {
    const json = JSON.stringify(query);
    return axios
        .delete('/api/feedback', {
            data: json,
            headers: {'Content-type': 'application/json'}
        })
        .then(response => response.data);
};


export default {
    getFeedbacks,
    getFeedback,
    getFeedbackDebug,
    getFeedbackDebugByExternalId,
    getFeedbackStats,
    exportFeedbackStats,
    deleteFeedbacks,
    getFeedbacksForAdmin,
    replayFeedbacks
};